import script from "./DLottieLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./DLottieLoader.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__